import { useEffect } from 'react'
import { useLocation } from 'react-router'

/**
 * Resets the window scroll position to the top whenever the route's pathname
 * changes. React Router's `<Routes>` (non-data) mode does not restore or reset
 * scroll on client-side navigation, so without this a link from a scrolled page
 * (e.g. "← Back to home" at the bottom of /terms) lands mid-page on the target.
 *
 * In-page hash links — the Terms/Privacy tables of contents — are left alone:
 * when a hash is present we scroll the target element into view instead of
 * jumping to the top, preserving anchor navigation.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)))
      if (el) {
        el.scrollIntoView()
        return
      }
    }
    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
